import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import axiosInstance from "../request";
import { URL } from "../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getPrivilegeList from "./PrivilegeList";

const Payment = () => {
  const [paymentData, setPaymentData] = useState({
    customerId: "",
    loanId: "",
    amount: "",

  });

  const [manualPayment, setManualPayment] = useState({
    customerId: "",
    loanId: "",
    paymentType: "Cash",
    paymentAmount: "",
    service: "",
    tranId: "",
    utr: "",
    tranDate: new Date().toISOString().split("T")[0],
    comment: "",
  });

  const [loading, setLoading] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  const privilegeList = getPrivilegeList();
  const [qrResponse, setQrResponse] = useState(null);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setPaymentData({ ...paymentData, [name]: value });
  };

  const handleManualChange = (e) => {
    const { name, value } = e.target;
    setManualPayment({ ...manualPayment, [name]: value });
  };


  const handleGenerateLink = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPaymentLink("");

    try {
      const res = await axiosInstance.get(URL.PAYMENT_LINK, {
        params: {
          customerId: paymentData.customerId,
          loanId: paymentData.loanId,
          amount: paymentData.amount,
          callbackUrl: "https://peday.money/",
        },
      });

      const link =
        res.data.short_url || res.data.payment_link || res.data.link || "";
      if (link) {
        setPaymentLink(link);
        toast.success("Payment link generated!", { position: "top-right" });
      } else {
        toast.warn("Link generated but not found in response", {
          position: "bottom-right",
        });
      }
    } catch (error) {
      console.error("Error generating payment link:", error);
      toast.error("Failed to generate link", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

 // ---------------- Generate QR ----------------
  const handleGenerateQR = async (e) => {
    e.preventDefault();
    setLoading(true);
    setQrResponse(null);

    if (!paymentData.customerId || !paymentData.qrDescription) {
      toast.error("Customer ID and QR Description are required", {
        position: "top-right",
      });
      setLoading(false);
      return;
    }

    try {
      const res = await axiosInstance.post(
        `${URL.GENERATE_QR}`,
        null,
        {
          params: {
            customerId: paymentData.customerId,
            description: paymentData.qrDescription,
          },
        }
      );

      if (res.data.success) {
        setQrResponse(res.data);
        toast.success("QR Code generated successfully!", {
          position: "top-right",
        });
      } else {
        toast.error(res.data.message || "QR generation failed", {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error generating QR:", error);
      toast.error("Failed to generate QR", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };


  const handleSendLink = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axiosInstance.get(URL.PAYMENT_LINK, {
        params: {
          customerId: paymentData.customerId,
          loanId: paymentData.loanId,
          amount: paymentData.amount,
          callbackUrl: "https://peday.money/",
        },
      });
      toast.success("Payment link sent to customer!", {
        position: "bottom-right",
      });
    } catch (error) {
      console.error("Error sending payment link:", error);
      toast.error("Failed to send payment link", { position: "bottom-right" });
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(paymentLink);
    toast.info("Copied to clipboard!", { position: "bottom-right" });
  };


  const generateManualUTR = () =>
    "MANUAL" + Math.floor(1000 + Math.random() * 9000);

  const handleManualPayment = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
    const payload = {
  paymentType: Number(manualPayment.paymentType), // convert to integer
  paymentAmount:
    manualPayment.paymentAmount.includes(".")
      ? Number(
          parseFloat(manualPayment.paymentAmount).toFixed(
            manualPayment.paymentAmount.split(".")[1].length
          )
        )
      : Number(manualPayment.paymentAmount),
  customerId: Number(manualPayment.customerId),
  loanId: Number(manualPayment.loanId),
  service:
    manualPayment.paymentType === "2" ? "Manual" : manualPayment.service, // compare string before conversion
  flag: 1,
  tranId:
    manualPayment.paymentType === "2"
      ? Math.floor(100000 + Math.random() * 900000).toString()
      : manualPayment.tranId,
  utr:
    manualPayment.paymentType === "2" ? generateManualUTR() : manualPayment.utr,
  tranDate: manualPayment.tranDate,
};



      await axiosInstance.post(URL.PAYMENTS, payload);
  const userId = localStorage.getItem("userId");

      if (manualPayment.comment) {
        const commentPayload = {
  customer_id: Number(manualPayment.customerId),
  loan_id: Number(manualPayment.loanId),
  comment: manualPayment.comment,
  comment_by: Number(userId),
  bypass_flag: 1,
  comment_type: 4,
};

        await axiosInstance.post(URL.COMMENT_ADD, commentPayload);
      }

      toast.success("Manual payment processed successfully!", {
        position: "top-right",
      });

      setManualPayment({
        customerId: "",
        loanId: "",
        paymentType: 2,
        paymentAmount: "",
        service: "",
        tranId: "",
        utr: "",
        tranDate: new Date().toISOString().split("T")[0],
        comment: "",
      });
    } catch (error) {
      console.error("Error processing manual payment:", error);
      toast.error("Failed to process manual payment", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="shadow rounded-3">
      <CardHeader className="bg-primary text-white">
        <h5 className="mb-0">Payments</h5>
      </CardHeader>
      <CardBody>
        {/* PayIn Form */}
        <h5>PayIn</h5>
        <div style={{ height: "7px" }}></div>
        <Form>
          <FormGroup>
            <Label for="customerId">Customer ID</Label>
            <Input
              type="text"
              id="customerId"
              name="customerId"
              value={paymentData.customerId}
              onChange={handleChange}
              placeholder="Enter Customer ID"
              required
            />
          </FormGroup>

          <FormGroup>
            <Label for="loanId">Loan ID</Label>
            <Input
              type="text"
              id="loanId"
              name="loanId"
              value={paymentData.loanId}
              onChange={handleChange}
              placeholder="Enter Loan ID"
              required
            />
          </FormGroup>

          <FormGroup>
            <Label for="amount">Payment Amount</Label>
            <Input
              type="number"
              id="amount"
              name="amount"
              value={paymentData.amount}
              onChange={handleChange}
              placeholder="Enter Amount"
              required
            />
          </FormGroup>

          <div className="d-flex justify-content-end gap-2">
            <Button
              color="info"
              onClick={handleGenerateLink}
              disabled={loading}
              type="button"
            >
              {loading ? "Processing..." : "Generate Payment Link"}
            </Button>
            <Button
              color="success"
              onClick={handleSendLink}
              disabled={loading}
              type="button"
            >
              {loading ? "Processing..." : "Send Payment Link"}
            </Button>
          </div>
        </Form>

        {paymentLink && (
          <div className="mt-3 p-3 border rounded bg-light">
            <p className="mb-1">
              <strong>Generated Link:</strong>
            </p>
            <div className="d-flex justify-content-between align-items-center">
              <p>{paymentLink}</p>
              <Button color="secondary" size="sm" onClick={handleCopy}>
                Copy
              </Button>
            </div>
          </div>
        )}

        {privilegeList.manualPaymentView && (<>
        <hr />
        <h5>Manual Payment</h5>
        <div style={{ height: "7px" }}></div>
        <Form onSubmit={handleManualPayment}>
          <FormGroup>
            <Label for="customerIdManual">Customer ID</Label>
            <Input
              type="text"
              id="customerIdManual"
              name="customerId"
              value={manualPayment.customerId}
              onChange={handleManualChange}
              placeholder="Enter Customer ID"
              required
            />
          </FormGroup>

          <FormGroup>
            <Label for="loanIdManual">Loan ID</Label>
            <Input
              type="text"
              id="loanIdManual"
              name="loanId"
              value={manualPayment.loanId}
              onChange={handleManualChange}
              placeholder="Enter Loan ID"
              required
            />
          </FormGroup>

          <FormGroup>
            <Label for="paymentType">Payment Type</Label>
            <Input
              type="select"
              id="paymentType"
              name="paymentType"
              value={manualPayment.paymentType}
              onChange={handleManualChange}
            >
             <option value="2">Cash</option>
              <option value="1">QR Scanner</option>
              <option value="5">Link</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label for="paymentAmount">Payment Amount</Label>
            <Input
              type="text"
              id="paymentAmount"
              name="paymentAmount"
              value={manualPayment.paymentAmount || ""}
              onChange={handleManualChange}
              placeholder="Enter Amount"
              required
            />
          </FormGroup>

          <FormGroup>
            <Label for="tranDate">Transaction Date</Label>
            <Input
              type="date"
              id="tranDate"
              name="tranDate"
              value={manualPayment.tranDate}
              onChange={handleManualChange}
              required
            />
          </FormGroup>

          {manualPayment.paymentType !== "Cash" && (
            <>
              <FormGroup>
                <Label for="service">Service</Label>
                <Input
                  type="text"
                  id="service"
                  name="service"
                  value={manualPayment.service}
                  onChange={handleManualChange}
                  placeholder="Enter Service (e.g., GPay, PhonePe)"
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label for="tranId">Transaction ID</Label>
                <Input
                  type="text"
                  id="tranId"
                  name="tranId"
                  value={manualPayment.tranId}
                  onChange={handleManualChange}
                  placeholder="Enter Transaction ID"
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label for="utr">UTR</Label>
                <Input
                  type="text"
                  id="utr"
                  name="utr"
                  value={manualPayment.utr}
                  onChange={handleManualChange}
                  placeholder="Enter UTR (if available)"
                />
              </FormGroup>
            </>
          )}

          <FormGroup>
            <Label for="comment">Comment</Label>
            <Input
              type="textarea"
              id="comment"
              name="comment"
              value={manualPayment.comment}
              onChange={handleManualChange}
              placeholder="Enter comment"
              required
            />
          </FormGroup>

          <div className="d-flex justify-content-end">
            <Button color="primary" type="submit" disabled={loading}>
              {loading ? "Processing..." : "Submit Manual Payment"}
            </Button>
          </div>
        </Form>
        </>)}

         {/* ---------------- QR Code Section ---------------- */}
        <hr />
        <h5>Generate QR Code</h5>
        <Form onSubmit={handleGenerateQR}>
          <FormGroup>
  <Label for="qrCustomerId">Customer ID</Label>
  <Input
    type="text"
    id="qrCustomerId"
    name="customerId"
    value={paymentData.customerId}
    onChange={handleChange}
    placeholder="Enter Customer ID"
    required
  />
</FormGroup>

          <FormGroup>
            <Label for="qrDescription">QR Description</Label>
            <Input
              type="text"
              id="qrDescription"
              name="qrDescription"
              value={paymentData.qrDescription}
              onChange={handleChange}
              placeholder="Enter QR Description"
              required
            />
          </FormGroup>

          <div className="d-flex justify-content-end">
            <Button color="primary" type="submit" disabled={loading}>
              {loading ? "Processing..." : "Generate QR Code"}
            </Button>
          </div>
        </Form>

        {qrResponse && (
          <div className="mt-3 p-3 border rounded bg-light">
            <p><strong>QR Code Generated:</strong></p>
            <p><strong>Customer ID:</strong> {qrResponse.customerId}</p>
            <p><strong>Status:</strong> {qrResponse.status}</p>
            <p><strong>QR ID:</strong> {qrResponse.qrId}</p>
            <p>
              <strong>Image URL:</strong>{" "}
              <a href={qrResponse.imageUrl} target="_blank" rel="noreferrer">
                {qrResponse.imageUrl}
              </a>
            </p>
            <Button
              color="secondary"
              size="sm"
              onClick={() => handleCopy(qrResponse.imageUrl)}
            >
              Copy Image URL
            </Button>
          </div>
        )}

        <ToastContainer />
      </CardBody>
    </Card>
  );
};

export default Payment;
